import { Label } from '@/components/ui/label';

export function CompulsoriesSection({ form, index, dances, updateGradeForm }) {
  return (
    <div className="mb-4 p-4 border rounded-lg bg-green-50">
      <h4 className="font-medium mb-3 text-green-800">Compulsory Dances</h4>
      <div className="space-y-3">
        <div>
          <Label>Dance 1 *</Label>
          <select 
            className="w-full border rounded-lg px-3 py-2 mt-1"
            value={form.dance_1_id}
            onChange={(e) => updateGradeForm(index, 'dance_1_id', e.target.value)}
            required
          >
            <option value="">Select Dance</option>
            {dances.map(d => (
              <option key={d.dance_id} value={d.dance_id}>{d.name} ({d.tempo})</option>
            ))}
          </select>
        </div>
        <div>
          <Label>Dance 2</Label>
          <select 
            className="w-full border rounded-lg px-3 py-2 mt-1"
            value={form.dance_2_id}
            onChange={(e) => updateGradeForm(index, 'dance_2_id', e.target.value)}
          >
            <option value="">Select Dance (Optional)</option>
            {dances.map(d => (
              <option key={d.dance_id} value={d.dance_id}>{d.name} ({d.tempo})</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
